import { render } from "./collegeEdit.vue?vue&type=template&id=cecb6402&scoped=true"
import script from "./collegeEdit.vue?vue&type=script&lang=js"
export * from "./collegeEdit.vue?vue&type=script&lang=js"

import "./collegeEdit.vue?vue&type=style&index=0&id=cecb6402&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cecb6402"]])

export default __exports__